export const ENV_FILE_NAME = 'dm3-ds.env';

export const CONFIG_FILE_NAME = 'config.yml';

export const DELIVERY_SERVICE = 'network.dm3.deliveryService';

export const PROFILE_PREFIX = 'data:application/json,';

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

export const GITHUB_SOURCE_CODE =
    'https://github.com/dm3-org/dm3-ds-setup-helper';

export const GITHUB_LICENSE =
    'https://github.com/dm3-org/dm3-ds-setup-helper/blob/main/LICENSE';

export const KEY_CREATION_MESSAGE =
    'I am creating the seed for a dm3 delivery service profile by signing this message.';

export const DOCKER_COMPOSE_DOWNLOAD_URL =
    'https://raw.githubusercontent.com/dm3-org/dm3/main/docker/ds-minimal/docker-compose.yml';
